import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import logo from '../../images/logo.svg';
import './Banner.css';
import { useLanguage } from '../../context/LanguageContext';

interface BannerProps {
  showMainContent?: boolean;
}

const Banner: React.FC<BannerProps> = ({ showMainContent = true }) => {
  const { t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToHowWeWork = () => {
    const howWeWorkSection = document.querySelector('#how-we-work-section');
    if (howWeWorkSection) {
      howWeWorkSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className={`banner-wrapper ${!showMainContent ? 'slim' : ''}`}>
      {/* Minimalist Dark Navbar */}
      <nav className={`navbar-dark ${isScrolled || !showMainContent ? 'scrolled' : ''}`}>
        <Container fluid className="px-4 px-md-5">
          <div className="navbar-content">
            <div className="navbar-logo" onClick={scrollToTop} role="button" tabIndex={0}>
              <img src={logo} alt="Lucods" style={{ height: '15rem', width: '15rem', marginTop: '-6.8rem', marginBottom: '-5rem' }} className="logo-img" />
            </div>
            <div className="navbar-actions">
              <button className="nav-link" onClick={scrollToContact}>
                {t('nav.contact')}
              </button>
            </div>
          </div>
        </Container>
      </nav>

      {/* Hero Section */}
      {showMainContent && (
        <div className="banner-hero">
          {/* Crystallized Gradient Background */}
          <div className="gradient-background">
            <div className="gradient-sphere sphere-1"></div>
            <div className="gradient-sphere sphere-2"></div>
            <div className="gradient-sphere sphere-3"></div>
            <div className="noise-overlay"></div>
            <div className="grid-overlay"></div>
            <div className="glow-effect"></div>
          </div>

          {/* Particles Container */}
          <div className="particles-container" id="particles-container">
            {Array.from({ length: 12 }).map((_, i) => (
              <div
                key={i}
                className={`particle particle-${['small', 'medium', 'large'][i % 3]}`}
                style={{
                  left: Math.random() * 100 + '%',
                  bottom: Math.random() * 100 + '%',
                  animationDelay: (i * 0.3) + 's',
                }}
              ></div>
            ))}
          </div>

          <Container fluid className="banner-content-wrapper">
            <div className="banner-hero-content">
              <h1 className="banner-title">
                Desarrollamos software a medida para empresas que{' '}
                <span className="highlight-purple">necesitan escalar su negocio</span>
              </h1>
              <div className="banner-divider"></div>
              <h2 className="banner-text">
                Creamos soluciones digitales adaptadas a tus procesos reales para reducir errores, automatizar tareas y acompañar el crecimiento de tu empresa.
              </h2>

              <div className="banner-buttons-container">
                <button className="banner-button-primary" onClick={scrollToContact}>
                  Quiero analizar mi proyecto
                </button>
                <button className="banner-button-secondary" onClick={scrollToHowWeWork}>
                  Ver soluciones
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
    </div>
  );
};

export default Banner;